import { ServiceFetch } from '../service-fetch'

export default class ProductGroupDiscoundListModel extends ServiceFetch {
    getProductGroupDiscoundListBy = (data) => this.authFetch({
        url: 'product-group-discound-list/getProductGroupDiscoundListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}